define('widgets/olark/dialog/olarkMobileDialogFactory',[
    'knockout',
    'plugins/dialog'
], function (ko, dialog) {

    var OlarkMobileDialogFactory = function (getField, HelpDialog) {
        var self = this,
            title = getField('help_text')(),
            helpDialog = new HelpDialog(title);

        self.openDialog = function () {
            dialog.showHelpDialog(helpDialog);
        };

    };

    return OlarkMobileDialogFactory;
});

